import { Dictionary } from 'lodash';
import { Theme, DeviceType, Upload, ThemeId } from 'shared/models';
import { ICommand, UpdateThemeCommand, UpdateSoftwareCommand, CommentCommand, SetCommand } from 'logic/deviceScriptParser';
import { UpdateThemeCommandOptions } from './UpdateThemeCommandOptions';
import { UpdateSoftwareCommandOptions } from './UpdateSoftwareCommandOptions';
import { SetCommandOptions } from './SetCommandOptions';
import { CommentCommandOptions } from './CommentCommandOptions';

export type Props = {
    index: number;
    deviceType: DeviceType | null;
    command: ICommand;
    themes: Record<ThemeId, Theme>;
    uploads: Record<string, Upload>;
    canMoveUp: boolean;
    canMoveDown: boolean;
    onClickUp(): void;
    onClickDown(): void;
    onClickDelete(): void;
    onClickTheme(themeId: string): void;
    onClickSoftware(filename: string): void;
    onClickForce(force: boolean): void;
    onChangeSetSetting(setting: string): void;
    onChangeSetValue(setting: string): void;
    onChangeComment(comment: string): void;
};

export const CommandLine = ({
    index, deviceType, command, themes, uploads, canMoveUp, canMoveDown,
    onClickUp, onClickDown, onClickDelete, onClickTheme, onClickSoftware,
    onClickForce, onChangeComment, onChangeSetSetting, onChangeSetValue,
}: Props) => {
    return (
        <div className="command-line">
            <span className="up-down-buttons">
                <button type="button" className="ui basic tiny icon button" onClick={ onClickUp } disabled={ !canMoveUp }>
                    <i className="arrow up icon"/>
                </button>
                <button type="button" className="ui basic tiny icon button" onClick={ onClickDown } disabled={ !canMoveDown }>
                    <i className="arrow down icon"/>
                </button>
            </span>
            <span className="command-name">
                { command.command }
            </span>
            <i className="remove icon" onClick={ onClickDelete }/>

            { command.command === 'update theme' &&
                <UpdateThemeCommandOptions
                    command={ command as UpdateThemeCommand }
                    themes={ themes }
                    deviceType={ deviceType }
                    onClickTheme={ onClickTheme }
                />
            }
            { command.command === 'update software' &&
                <UpdateSoftwareCommandOptions
                    index={ index }
                    command={ command as UpdateSoftwareCommand }
                    uploads={ uploads }
                    deviceType={ deviceType }
                    onClickSoftware={ onClickSoftware }
                    onClickForce={ onClickForce }
                />
            }
            { command.command === 'comment' &&
                <CommentCommandOptions
                    index={ index }
                    command={ command as CommentCommand }
                    onChangeComment={ onChangeComment }
                />
            }
            { command.command === 'set' &&
                <SetCommandOptions
                    index={ index }
                    command={ command as SetCommand }
                    onChangeSetSetting={ onChangeSetSetting }
                    onChangeSetValue={ onChangeSetValue }
                />
            }
        </div>
    );
};
